// CompanySettings.currency is stored as either a symbol ('£') or an ISO code
// ('GBP') depending on how the tenant was set up, so anything rendering an
// input adornment or a price should go through here rather than printing
// the raw value (the demo tenant would otherwise show "GBP0.00").

const CODE_TO_SYMBOL = { GBP: '£', EUR: '€', USD: '$' }
const SYMBOL_TO_CODE = { '£': 'GBP', '€': 'EUR', $: 'USD' }

export const getCurrencySymbol = (currency) => {
  if (!currency) return '£'
  const value = String(currency).trim()
  return CODE_TO_SYMBOL[value.toUpperCase()] ?? value
}

export const getCurrencyCode = (currency) => {
  if (!currency) return 'GBP'
  const value = String(currency).trim()
  if (/^[A-Za-z]{3}$/.test(value)) return value.toUpperCase()
  return SYMBOL_TO_CODE[value] ?? 'GBP'
}

export const formatMoney = (value, currency, options = {}) =>
  new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: getCurrencyCode(currency),
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    ...options,
  }).format(Number(value) || 0)
